import React from 'react';
import styled from 'styled-components';
import { AppColors } from 'helpers';
import { Div, HorizontalView, VerticalView } from 'vendor-deprecated/Wrapper';
import { TextDisplay } from 'vendor-deprecated/Text';
import { ICourse, ICourseLesson } from 'types/types';
import { SVGIcon } from 'vendor-deprecated/Icon';
import { useTranslationText } from 'locale';
import { Hr } from 'vendor-deprecated/CommonParts';

const SyllabusWrapper = styled.div`
  width: 100%;
  background: ${AppColors.WHITE};
`;

const BoxContent = styled.div`
  width: 100%;
  border: 1px solid ${AppColors.BORDER};
  padding: 20px;
  background: ${AppColors.BODY_BACKGROUND};
  margin-bottom: 20px;
  border-radius: 4px;
`;

export interface SyllabusProps {
  course: ICourse;
  lessons?: ICourseLesson[];
}

export const Syllabus = React.memo((props: SyllabusProps) => {
  const { translation } = useTranslationText();

  return (
    <SyllabusWrapper>
      <VerticalView width={'100%'} alignContent={'centerLeft'}>
        <BoxContent>
          <TextDisplay fontWeight={600} size={'18px'} color={AppColors.DARK} marginBottom={'15px'}>
            {translation('skillsYouWillGain')}
          </TextDisplay>
          <Hr />
          <VerticalView width={'100%'} alignContent={'centerLeft'} marginTop={'15px'}>
            {props.course.skills?.map((title, index) => {
              return (
                <HorizontalView
                  key={index}
                  fullWidth
                  marginTop={'5px'}
                  marginBottom={'5px'}
                  alignContent={'topLeft'}
                  flexWrap={'nowrap'}
                >
                  <Div paddingTop={'5px'}>
                    <SVGIcon name={'check'} color={AppColors.DARK} size={'15px'} />
                  </Div>

                  <TextDisplay size={'16px'} marginLeft={'10px'} width={'calc(100% - 35px)'}>
                    {title}
                  </TextDisplay>
                </HorizontalView>
              );
            })}
          </VerticalView>
        </BoxContent>
        {props.course.type === 'COURSE' && (
          <BoxContent>
            <VerticalView alignContent={'centerLeft'}>
              <TextDisplay fontWeight={600} size={'18px'} color={AppColors.DARK} marginBottom={'15px'}>
                {translation('whatYouWillLearn')}
              </TextDisplay>
              <Hr />
              <VerticalView width={'100%'} alignContent={'centerLeft'} marginTop={'15px'}>
                {props.lessons &&
                  props.lessons.map((lesson, index) => {
                    return (
                      <HorizontalView
                        fullWidth
                        key={index}
                        alignContent={'centerLeft'}
                        marginTop={'5px'}
                        marginBottom={'5px'}
                      >
                        <Div>{index + 1},</Div>
                        <TextDisplay size={'16px'} marginLeft={'10px'} width={'calc(100% - 40px)'}>
                          {lesson.title}
                        </TextDisplay>
                      </HorizontalView>
                    );
                  })}
              </VerticalView>
            </VerticalView>
          </BoxContent>
        )}

        <BoxContent>
          <TextDisplay fontWeight={600} size={'20px'} color={AppColors.DARK} marginBottom={'15px'}>
            {translation('description')}
          </TextDisplay>
          <Hr />
          <Div fullWidth overflow={'hidden'} marginTop={'15px'} alignContent={'centerLeft'}>
            <div style={{ width: '100%' }} dangerouslySetInnerHTML={{ __html: props.course?.content || '' }} />
          </Div>
        </BoxContent>
      </VerticalView>
    </SyllabusWrapper>
  );
});
